import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_cptgb5am9n: FaireBrandEntity = {
  token: "b_cptgb5am9n",
  type: "brand",
  name: "Vitamatic",
  avatarUrl:
    "https://cdn.faire.com/fastly/21e511f76c74a1f53f9506f4b856326da7f0c340573cb567d54f4bc624e8d35f.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/59a24ec08fe37192acfbeb044570021624a98699ffad8e32fa07362961bd1ec3.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/21e511f76c74a1f53f9506f4b856326da7f0c340573cb567d54f4bc624e8d35f.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/59a24ec08fe37192acfbeb044570021624a98699ffad8e32fa07362961bd1ec3.jpeg",
  location: "08869, NJ, USA",
  minimumOrderDollars: 100,
  rating: 4.6,
  reviewCount: 57,
  isInsider: true,
  description:
    "At Vitamatic our mission consists of 3 major pillars:\n\n1. Premium quality ingredients: We strive to provide natural supplements created with pure and top quality ingredients to promote optimal health and performance\n\n2. Competitive pricing: We offer affordable pricing, because we believe that every individual committed to a better quality of life should have the opportunity to do so without financial burdens\n\n3. Superior service: We pride ourselves in how we support and guide our customers on their wellness journey to help meet their health goals",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:33.817Z",
    importedBy: "entity-db-cli",
  },
};
